import React from 'react';
import clsx from 'clsx';
import { List } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const EditableListDescriptionContainer = ({
  onClick,
  content,
  children,
  message = 'click.to.edit',
  className,
}) => {
  const intl = useIntl();

  if (content) {
    return (
      <List.Description
        className={clsx('aridhia-editable-list-description', className)}
        onClick={onClick}
      >
        {children}
      </List.Description>
    );
  }

  return (
    <List.Description
      className={clsx('aridhia-editable-list-description no-content', className)}
      onClick={onClick}
      content={intl.formatMessage({ id: message })}
    />
  );
};

export default EditableListDescriptionContainer;
